// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"f3412ad4","811":"2512e6a1"}[chunkId] + ".chunk.js";
};